import { Routes, Route } from 'react-router-dom-v5-compat'
import ProductDetails from './ProductDetails'
import ProductEdit from './ProductAddModal/ProductEdit'
import ItemsList from './ItemsList'
import Margin from '../Home/Margin/Margin'
import { Products } from './Products'

const ProductsRoutes = () => {
    return (
      <Routes>
          <Route path="products/edit">
              <Route index element={<ProductEdit/>}/>
              <Route path=":id" element={<ProductEdit/>}/>
          </Route>
          <Route path="products" element={<Products/>}>
              <Route index element={<ItemsList/>}/>
              <Route path="margin" element={<Margin/>}/>
          </Route>
          <Route path="products/:id" element={<ProductDetails/>}/>
          <Route path="/" element={<Products/>}/>
      </Routes>
    )
}

export { ProductsRoutes }
